import { useEffect, useState, useContext, startTransition } from 'react';
import { GlobalState } from "./../../../context/globalState";
import { Row, Col, Radio, Form, message } from "antd"
import Images from "./../../../asset/exportImages";
import Button from "./../../../components/button/index";
import Server from "./../../../lib/getAPI";
import dayjs from "dayjs";
import { trackProductEvent } from '../../../lib/trackingService';

const Packeds = () => {
  const { isMobile, Helper, packages, dataOrder, setDataOrder, setStep, OpenLink, setDataFees, listOfInsuredPeople, dataFees, scrollIntoViewID } = useContext(GlobalState);
  const [selectedIds, setSelectedIds] = useState(isMobile ? [] : ['bao_ve_gia_dinh_1', 'bao_ve_gia_dinh_2', 'bao_ve_gia_dinh_3']);
  const [form] = Form.useForm();
  const [submittable, setSubmittable] = useState(false);
  const [err, setErr] = useState(false);
  const values = Form.useWatch([], form);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      form
        .validateFields({ validateOnly: true })
        .then(() => setErr(false))
        .catch(() => setSubmittable(false));
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [form, values]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setDataFees({
      ...dataFees,
      totalInsured: (listOfInsuredPeople?.length || 1) * dataOrder?.fees,
    });
    if (dataOrder?.packageCode) {
      trackProductEvent("product_package_selected", {
        package_id: dataOrder?.packageCode,
        price: dataOrder?.fees || 0,
      });
    }
  }, []);

  const toggleSelection = (id) => {
    trackProductEvent("product_benefit_expand", {
      benefit_id: id,
    });
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((itemId) => itemId !== id)
        : [...prevSelectedIds, id]
    );
  };

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        trackProductEvent("product_quote_continue_click", {
          product_id: 93,
        });
        setStep(3);
      })
      .catch((err) => {
        message.error('Vui lòng chọn chương trình bảo hiểm');
        // console.error("err:", err);
      });
  };

  return (
    <>
      <Form
        layout={"vertical"}
        form={form}
        onFinish={onFinish}
        onFinishFailed={(e) => {
          scrollIntoViewID(e?.errorFields?.[0]?.name?.[0]);
          setErr(true);
        }}
        requiredMark={(label, { required }) => (
          <>
            {label}
            {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
          </>
        )}
        initialValues={{
          packageCode: dataOrder?.packageCode
        }}
      >
        <Row gutter={isMobile ? [0, 15] : [0, 30]} style={{ maxWidth: 900, margin: '0px auto' }}>
          <Col xs={24} xl={24}>
            <img src={isMobile ? Images.Banner2 : Images.Banner2} style={{ borderRadius: isMobile ? 8 : 16, width: '100%' }} />
          </Col>
          <Col xs={24} xl={24}>
            <div style={{ fontSize: isMobile ? 18 : 20, color: '#343A40' }}><b>Chọn chương trình bảo hiểm</b></div>
          </Col>
          <Col xs={24}>
            {
              err &&
              <div style={{ marginBottom: 10 }}><i style={{ color: '#FD1D1D' }}>Vui lòng chọn thông tin</i></div>
            }
            <Form.Item name='packageCode' label="" rules={[{ required: true, message: '' }]}>
              <Radio.Group style={{ width: '100%' }}>
                <Row gutter={isMobile ? [15, 15] : [50, 50]}>
                  {
                    (packages || [])?.map((data, index) => (
                      <Col
                        key={data.uid} xs={24} md={24} xl={24} >
                        <div className="card">
                          <div className="card-header" onClick={() => {
                            form.setFieldsValue({ packageCode: data?.code });
                            setDataOrder({ ...dataOrder, ...data, packageCode: data?.code, dateSaveData: dayjs().format('DD/MM/YYYY') });
                            setDataFees({
                              ...dataFees,
                              totalInsured: (listOfInsuredPeople?.length || 1) * data?.fees,
                            });
                            trackProductEvent("product_package_selected", {
                              package_id: data?.code,
                              price: data?.fees || 0,
                            });
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                <img style={{ width: 42, objectFit: 'cover' }} src={data?.urlIcon} alt="logo" />
                                <b className="title">{data?.title}</b>
                              </div>
                              <Radio value={data?.code}></Radio>
                            </div>
                            <div style={{ width: '100%', height: '0.5px', background: '#d2d2d2' }}></div>
                            <div className="info-row">
                              <div style={{ color: '#646D69', fontSize: 14 }}>Phí bảo hiểm/người/năm:</div>
                              <div className="highlight">{Helper.formatMoney(data?.fees)} VNĐ</div>
                            </div>

                            {
                              Helper.getParamUrlByKey('platform') === 'app' &&
                              <div className="info-row">
                                <div style={{ color: '#646D69', fontSize: 14 }}>Lương doanh thu:</div>
                                <div style={{ color: '#343A40' }} className="highlight">{Helper.formatMoney(data?.commission)} VNĐ</div>
                              </div>
                            }
                            <div className="info-row">
                              <div style={{ color: '#646D69', fontSize: 14 }}>Thời hạn bảo hiểm:</div>
                              <div style={{ color: '#343A40' }} className="highlight">{data?.yearsOfInsurance} năm</div>
                            </div>
                          </div>

                          <div className='gray' style={{ display: 'grid', gap: 10 }}>
                            <div onClick={() => toggleSelection(data.code)} className="link-detail" style={{ fontWeight: 500 }}>
                              {selectedIds.includes(data.code) ? 'Thu gọn' : 'Xem chi tiết quyền lợi'}
                              <img style={{ rotate: selectedIds.includes(data.code) ? '180deg' : '' }} src={Images.ICChevronDouble} width={16} alt="info" />
                            </div>
                            {
                              selectedIds.includes(data.code) &&
                              <>
                                <div className="info-row">
                                  <div style={{ color: '#646D69', fontSize: 14 }}>Tổng quyền lợi bảo hiểm/{isMobile ? <br /> : ''}người/thời hạn bảo hiểm:</div>
                                  <div style={{ color: '#009B4B', minWidth: 120 }} className="highlight">{Helper.formatMoney(data?.benefits?.totalFees)} VNĐ</div>
                                </div>
                                <div className="info-row">
                                  <div style={{ color: '#646D69', fontSize: 14 }}>1. Tử vong hoặc mất tích:</div>
                                  <div style={{ color: '#343A40', minWidth: 120 }} className="highlight">{Helper.formatMoney(data?.benefits?.deathOrDisappearanceFees)} VNĐ</div>
                                </div>
                                <div className="info-row">
                                  <div style={{ color: '#646D69', fontSize: 14 }}>2. Thương tật toàn bộ vĩnh viễn:</div>
                                  <div style={{ color: '#343A40', minWidth: 120 }} className="highlight">{Helper.formatMoney(data?.benefits?.permanentDisabilityFees)} VNĐ</div>
                                </div>
                                <div className="info-row">
                                  <div style={{ color: '#646D69', fontSize: 14 }}>3. Thương tật bộ phận vĩnh viễn:</div>
                                  <div onClick={() => OpenLink('https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/bang-ty-le-tra-tien-thuong-tat.pdf')} style={{ color: '#0044CC', textDecoration: 'underline', cursor: 'pointer', minWidth: 190, textAlign: 'right' }}>
                                    Bảng tỷ lệ trả tiền thương tật
                                  </div>
                                </div>
                                <div className="info-row">
                                  <div style={{ color: '#646D69', fontSize: 14 }}>4. Thương tật tạm thời:</div>
                                  <div onClick={() => OpenLink('https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/bang-ty-le-tra-tien-thuong-tat.pdf')} style={{ color: '#0044CC', textDecoration: 'underline', cursor: 'pointer', minWidth: 190, textAlign: 'right' }}>
                                    Bảng tỷ lệ trả tiền thương tật
                                  </div>
                                </div>
                                <div style={{ background: '#FFF6EE', padding: 5, borderRadius: 8, fontSize: 12, color: '#FB7800' }}>
                                  <i>*Ghi chú: Tổng số tiền bảo hiểm chi trả cho các mục từ 1-4: không vượt quá tổng quyền lợi bảo hiểm/người</i>
                                </div>
                              </>
                            }
                          </div>
                        </div>
                      </Col>
                    ))
                  }
                </Row>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Button showFees={true} disabled={!submittable} />
      </Form>
      <style jsx>{`
        .card {
          background: #fff;
          border-radius: 16px;
          padding: 10px;
          box-shadow: 0px 0px 8px 0px #0000001a;
          display: grid;
          gap: 10px;
          border: ${err ? '0.5px solid #FD1D1D' : '0.5px solid #d2d2d2'} ;
        }

        .card-header {
          background: #f0f2f5;
          border-radius: 8px;
          padding: 10px;
          display: grid;
          gap: 10px;
        }

        .logo-box {
          background: #fff;
          border-radius: 8px;
          padding: 10px;
          width: 80px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-box img {
          object-fit: cover;
        }

        .card-body {
          width: 100%;
          display: grid;
          flex: 1;
          margin-top: -10px;
          margin-bottom: -10px
        }

        .title-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .title {
          font-size: 16px;
          color: #343A40;
        }

        .info-row {
          font-size: 14px;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 10px;
        }

        .info-row.gray {
          color: #646d69;
          align-items: flex-start;
        }

        .highlight {
          color: #fb7800;
          font-weight: 500;
          ,fontSize: 14 
        }

        .success {
          color: #009b4b;
          font-weight: 600;
        }

        .link-detail {
          font-size: 12px;
          color: #343a40;
          display: flex;
          align-items: center;
          gap: 5px;
          cursor: pointer;
          font-weight: 500;
        }
      `}</style>
    </>
  );
}

export default Packeds;